import Joi from 'joi'
import ConsoleError from '@/modules/core/models/errors/ConsoleError'

export default Joi.object({
  businessLine: Joi.string().required(),
  businessLineId: Joi.string().required(),
  maxInsurances: Joi.number().integer().min(0).required(),
  maxDays: Joi.number().integer().min(0).required(),
  hiringMaxAges: Joi.object({
    holderInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    holderNotInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    insured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required()
  }).required(),
  billingCycles: Joi.object({
    monthly: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    quarterly: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    semiannual: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    annual: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  houseTypes: Joi.object({
    apartment: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    house: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  relationships: Joi.array()
    .items(
      Joi.object({
        id: Joi.string().required(),
        text: Joi.string().required(),
        holder: Joi.boolean().required(),
        default: Joi.boolean().required(),
        disabled: Joi.boolean().required(),
        maxSelectable: Joi.string().required().allow('')
      })
    )
    .required(),
  genders: Joi.object({
    female: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    male: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  //Los tags tienen que ir al final para que se muestren en consola mientras el resto de errores se muestran en pantalla de error
  tags: Joi.object({
    relationshipAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    holderAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    personalDataAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    personalDataInsuredAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    contactDataAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    contactDataInsuredAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    customDateAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    hasHealthInsuranceMeTitle: Joi.string().required(),
    hasHealthInsuranceMeAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    hasHealthInsuranceMeAndOthersTitle: Joi.string().required(),
    hasHealthInsuranceMeAndOthersAlert: Joi.object({
      title: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    hasHealthInsuranceOthersTitle: Joi.string().required(),
    hasHealthInsuranceOthersAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    hasHealthInsuranceOtherTitle: Joi.string().required(),
    hasHealthInsuranceOtherAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    familyDiscountHintView: Joi.object({
      label: Joi.string().required(),
      text1: Joi.string().required(),
      text2: Joi.string().required(),
      forOnlyFamilyBtn: Joi.string().required(),
      forAllBtn: Joi.string().required()
    }).required(),
    policyNumberAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    })
  })
    .required()
    .error((errors) => {
      const text = `DXP Dental branch configuration - ${errors.map((e) => `"${e.local.label}" is required`).join()}`
      return new ConsoleError({ message: text })
    })
    .unknown(true)
})
